import { gql } from '@apollo/client';

export const SSO_COOKIE_MUTATION = gql`
  mutation SsoCookie {
    ssoCookie {
      _id
      userId
      token
      createdDate
      expiredDate
    }
  }
`;
